export const ApiPath = {
  Login: 'admin',
  Tfa: 'enable2fa',
  TfaVer: 'verify2fa',
  Service: 'pass/pass_service',
};

export function GetHostUrl(key, hosts) {
  const host = hosts[key];
  // const cHost = host['host'];
  const domain = host['domain'];
  const endPoint = host['endPoint'];
  const protocol = domain === 'localhost' ? 'http' : 'https';
  const hosDom = getDomain(host);
  let hostPath = `${protocol}://${hosDom}`;
  if (endPoint) hostPath += `/${endPoint}/`;
  else hostPath += '/';
  return hostPath;
}

function getDomain(host) {
  const cPort = host['port'];
  const cHost = host['host'];
  const domain = host['domain'];
  const isLocal = domain === 'localhost';
  const hostPath = isLocal ? 'localhost' : `${cHost}.${domain}`;
  const port = isLocal ? `:${cPort}` : '';
  return `${hostPath}${port}`;
}
